export default __webpack_public_path__ + "static/shopify_logo_small-6b49cdefc84ac863046633ca19b8f8d8.jpeg";